(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('emailDao', ["http", "singleRowConverter", "sqlQueries", "defaultListConverter", "mimeIcons", "attachmentsListConverter", "emailScanEventsListConverter", "errorStatusHolder", "$q", "modulesManager", "troubleshooting", "servicenowHeaderConverter", "$timeout", "slowdownHelper", "mailHeaderConverterMT", "mailBodyConverterMT", "parseMIMEByRFC2047", "securityEventsConverters", function (http, singleRowConverter, sqlQueries, defaultListConverter, mimeIcons, attachmentsListConverter, emailScanEventsListConverter, errorStatusHolder, $q, modulesManager, troubleshooting, servicenowHeaderConverter, $timeout, slowdownHelper, mailHeaderConverterMT, mailBodyConverterMT, parseMIMEByRFC2047, securityEventsConverters) {
        return {
            retrieve: function (emailId, exportFormat, saas) {
                return http.get(sqlQueries('entity/email', exportFormat, saas)).params({ entity_id: emailId }).converter(singleRowConverter).cache('emailDao.retrieve-' + emailId, 5000).onRequestFail(function (error) {
                    if (error.status === 404) {
                        errorStatusHolder.errorStatus(404);
                    }
                    return $q.reject(error);
                });
            },
            recipientsList: function (columns, emailId, groupByType) {
                var result = http.get(sqlQueries('email_recipients')).params({ email_id: emailId });
                result.converter(function (input) {
                    _(input.data.rows).each(function (row) {
                        _(row).each(function (column, key) {
                            if (_(column).isString) {
                                row[key] = parseMIMEByRFC2047.decode(column);
                            }
                        });
                    });
                    return $q.when(input);
                });
                if (groupByType) {
                    result.converter(function (input) {
                        var typesMap = {};
                        _(input.data.rows).each(function (row) {
                            typesMap[row.type] = typesMap[row.type] || {
                                type: row.type,
                                type_order: row.type_order,
                                users: []
                            };
                            typesMap[row.type].users.push(row);
                        });
                        return $q.when({
                            data: {
                                rows: _(typesMap).chain().map(function (data) {
                                    return {
                                        type: data.type,
                                        type_order: data.type_order,
                                        users: data.users
                                    };
                                }).sortBy('type_order').value()
                            }
                        });
                    });
                }
                return result.converter(defaultListConverter, {
                    columns: columns,
                    converters: {
                        'inlineUserWithEmail': function (text, columnId, columnsMap, args) {
                            var result = text;
                            if (args.emailColumn && columnsMap[args.emailColumn]) {
                                result += ' (' + columnsMap.mail + ')';
                            }
                            if (args.userIdColumn && columnsMap[args.userIdColumn]) {
                                result = '#' + JSON.stringify({
                                    display: 'link',
                                    type: 'user',
                                    id: columnsMap[args.userIdColumn],
                                    text: result,
                                    'class': 'meta-info-col left-col'
                                });
                            }
                            if (args.addAllEmailsLink && troubleshooting.entityDebugEnabled() && columnsMap.type === 'From' && args.userIdColumn && columnsMap[args.userIdColumn]) {
                                result += ' #' + JSON.stringify({
                                    display: 'text',
                                    text: 'Show all conversations',
                                    'class': 'link-like show-all-user-emails-link meta-info-col right-col',
                                    clickEvent: {
                                        name: 'show-all-user-emails',
                                        userId: columnsMap[args.userIdColumn]
                                    }
                                });
                            }
                            return result;
                        }
                    }
                });
            },
            attachmentsList: function (columns, emailId, entityType, query, queryField) {
                var params = {};
                params[queryField || 'email_id'] = emailId;
                return http.get(sqlQueries(query || 'email_attachments')).params(params).preFetch(mimeIcons(), 'mimeIcons').converter(attachmentsListConverter, function () {
                    return { entityType: entityType };
                });
            },
            conversationList: function (columns, emailId) {
                return http.get(sqlQueries('email_conversation')).params({ email_id: emailId }).converter(defaultListConverter, { columns: columns });
            },
            splittedEmailsList: function (columns, emailId) {
                return http.get(sqlQueries('splitted_emails')).params({ email_id: emailId }).converter(defaultListConverter, { columns: columns }).showTotalRows(false);
            },
            getTotalSplittedEmails: function (emailId) {
                return http.get(sqlQueries('splitted_emails')).params({
                    email_id: emailId,
                    limit: 1
                });
            },
            scanEvents: function (columns, emailId, options, query, queryField) {
                var params = {};
                params[queryField || 'email_id'] = emailId;
                return http.get(sqlQueries(query || 'email_attachments')).params(params).converter(emailScanEventsListConverter, function (preFetches) {
                    return $.extend({ entityId: emailId }, options);
                }).converter(defaultListConverter, function (preFetches) {
                    return {
                        columns: columns,
                        converters: securityEventsConverters
                    };
                });
            },
            topOutgoingDomains: function (after, internal) {
                return http.get(sqlQueries('top_outgoing_domains')).params({
                    after: after,
                    internal: internal
                });
            },
            retrieveHeader: function (entityId) {
                // retired, but not sure about servicenow
                if (modulesManager.currentModule() == 'servicenow') {
                    return http.get(sqlQueries('entity/email')).params({ entity_id: entityId }).converter(servicenowHeaderConverter);
                }
                return $q.reject({ status: 404 });
            },
            retrieveHeaderForMT: function (entityId) {
                if (modulesManager.currentModule() === 'google_mail' || modulesManager.currentModule() === 'office365_emails') {
                    return http.get('/api/v1/mta/email_headers/' + entityId + '/' + modulesManager.currentModule()).converter(mailHeaderConverterMT);
                }
                return $q.reject({ status: 404 });
            },
            retrieveHeaderRawForMT: function (entityId) {
                if (modulesManager.currentModule() === 'google_mail' || modulesManager.currentModule() === 'office365_emails') {
                    return http.get('/api/v1/mta/email_headers/' + entityId + '/' + modulesManager.currentModule() + '?raw=true');
                }
                return $q.reject({ status: 404 });
            },
            retrieveBodyForMT: function (entityId) {
                if (modulesManager.currentModule() === 'google_mail' || modulesManager.currentModule() === 'office365_emails') {
                    return http.get('/api/v1/mta/email_body/' + entityId + '/' + modulesManager.currentModule()).converter(mailBodyConverterMT);
                }
                return $q.reject({ status: 404 });
            },
            quarantine: function (columns) {
                return http.get(sqlQueries('quarantine_emails')).converter(defaultListConverter, function (preFetches) {
                    return { columns: columns };
                }).showTotalRows(false);
            },
            quarantine_detail: function (columns, entityId) {
                if (columns) {
                    return http.get(sqlQueries('quarantine_email_detail')).params({ id: entityId }).converter(defaultListConverter, function (preFetches) {
                        return { columns: columns };
                    });
                }
                return http.get(sqlQueries('quarantine_email_detail')).params({ id: entityId });
            },
            quarantine_getTotal: function () {
                return http.get(sqlQueries('quarantine_emails')).params({ limit: 1 });
            },
            threatExtractedEmails: function (columns) {
                return http.get(sqlQueries('attachment_changed_emails')).converter(defaultListConverter, function (preFetches) {
                    return { columns: columns };
                }).showTotalRows(false);
            },
            threatExtractedEmail_detail: function (columns, entityId) {
                if (columns) {
                    return http.get(sqlQueries('attachment_changed_email_detail')).params({ id: entityId }).converter(defaultListConverter, function (preFetches) {
                        return { columns: columns };
                    });
                }
                return http.get(sqlQueries('attachment_changed_email_detail')).params({ id: entityId });
            },
            threatExtractedEmails_getTotal: function () {
                return http.get(sqlQueries('attachment_changed_emails')).params({ limit: 1 });
            },
            retrieveByQuarantineUuid: function (msg) {
                return http.get(sqlQueries('email_by_quarantine_uuid')).params({ msg: msg }).converter(singleRowConverter);
            },
            allUserEmails: function (columns, userId, direction, converters) {
                return http.get(sqlQueries('user_emails' + (direction ? '_' + direction : ''))).params({ user_id: userId }).converter(defaultListConverter, function (preFetches) {
                    return {
                        columns: columns,
                        converters: converters
                    };
                });
            },
            emailSource: function (moduleName, entityType, entityId) {
                return http.get('/api/v1/sec_match_file/' + entityType + '/' + moduleName + '/' + entityId);
            },
            similarEmailCount: function (entityType, entityId, mode, timeoutPromise) {
                function requestSimilar() {
                    return http.get('/api/v1/similar_email_count/' + entityType + '/' + entityId).params({ mode: mode });
                }
                var reloadOnErrorTimeout = 10000;
                function queryReloader(getQuery, timeoutPromise) {
                    return getQuery().timeout(timeoutPromise).onRequestFail(function (error) {
                        if (error.status === 502 || error.status === 504) {
                            return $timeout(slowdownHelper.adjustInterval(reloadOnErrorTimeout)).then(function () {
                                return queryReloader(getQuery, timeoutPromise);
                            });
                        }
                        return $q.when({ data: { count: 0 } });
                    });
                }
                return queryReloader(requestSimilar, timeoutPromise);
            },
            restoreRequests: function () {
                return http.get(sqlQueries('restore_requests'));
            },
            phishingReports: function () {
                return http.get(sqlQueries('phishing_reports'));
            },
            extractedRestoreRequests: function () {
                return http.get(sqlQueries('original_restore_requests'));
            },
            getEncryptionStatus: function (entityId) {
                return http.get('/api/v1/entity/encryption_status/office365_emails_email/' + entityId);
            },
            getO365EmailsRestoreRequestFields: function (entityId) {
                return http.get('/api/v1/o365_restore_request_fields/office365_emails_email/' + entityId);
            }
        };
    }]);
}());